import { render } from "./NoteView.vue?vue&type=template&id=6756731a&scoped=true"
import script from "./NoteView.vue?vue&type=script&lang=js"
export * from "./NoteView.vue?vue&type=script&lang=js"

import "./NoteView.vue?vue&type=style&index=0&id=6756731a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6756731a"]])

export default __exports__